"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5923,3694],{

/***/ 33694:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ChainMismatchError": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Yl; },
/* harmony export */   "ChainNotConfiguredError": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.X4; },
/* harmony export */   "Config": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.De; },
/* harmony export */   "ConfigChainsNotFound": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.gs; },
/* harmony export */   "Connector": function() { return /* reexport safe */ _chunk_BVC4KGLQ_js__WEBPACK_IMPORTED_MODULE_1__.wR; },
/* harmony export */   "ConnectorAlreadyConnectedError": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.wi; },
/* harmony export */   "ConnectorNotFoundError": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_2__.N; },
/* harmony export */   "InjectedConnector": function() { return /* reexport safe */ _chunk_EQOEZP46_js__WEBPACK_IMPORTED_MODULE_3__._; },
/* harmony export */   "SwitchChainNotSupportedError": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.OJ; },
/* harmony export */   "configureChains": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.QB; },
/* harmony export */   "connect": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.$j; },
/* harmony export */   "createConfig": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__._g; },
/* harmony export */   "createStorage": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.o6; },
/* harmony export */   "deepEqual": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.vZ; },
/* harmony export */   "deserialize": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.vB; },
/* harmony export */   "disconnect": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.zP; },
/* harmony export */   "erc20ABI": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.em; },
/* harmony export */   "erc4626ABI": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.yS; },
/* harmony export */   "erc721ABI": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.YD; },
/* harmony export */   "fetchBalance": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.EG; },
/* harmony export */   "fetchBlockNumber": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.RQ; },
/* harmony export */   "fetchEnsAddress": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.bh; },
/* harmony export */   "fetchEnsAvatar": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.w6; },
/* harmony export */   "fetchEnsName": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Lk; },
/* harmony export */   "fetchEnsResolver": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Uj; },
/* harmony export */   "fetchFeeData": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.jS; },
/* harmony export */   "fetchToken": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.EC; },
/* harmony export */   "fetchTransaction": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.KI; },
/* harmony export */   "getAccount": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.D0; },
/* harmony export */   "getConfig": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.iE; },
/* harmony export */   "getContract": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.uN; },
/* harmony export */   "getNetwork": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Hy; },
/* harmony export */   "getPublicClient": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.uV; },
/* harmony export */   "getUnit": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Wy; },
/* harmony export */   "getWalletClient": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.xz; },
/* harmony export */   "getWebSocketPublicClient": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.jr; },
/* harmony export */   "mainnet": function() { return /* reexport safe */ _chunk_4E64EZ7V_js__WEBPACK_IMPORTED_MODULE_4__.R; },
/* harmony export */   "multicall": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Ap; },
/* harmony export */   "noopStorage": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.wp; },
/* harmony export */   "prepareSendTransaction": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.uw; },
/* harmony export */   "prepareWriteContract": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.$q; },
/* harmony export */   "readContract": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.a4; },
/* harmony export */   "readContracts": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.JH; },
/* harmony export */   "sendTransaction": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.T7; },
/* harmony export */   "sepolia": function() { return /* reexport safe */ _chunk_4E64EZ7V_js__WEBPACK_IMPORTED_MODULE_5__.F; },
/* harmony export */   "serialize": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.qC; },
/* harmony export */   "signMessage": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.l; },
/* harmony export */   "signTypedData": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.xq; },
/* harmony export */   "switchNetwork": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.If; },
/* harmony export */   "waitForTransaction": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Mn; },
/* harmony export */   "watchAccount": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.uH; },
/* harmony export */   "watchBlockNumber": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.qu; },
/* harmony export */   "watchContractEvent": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Y$; },
/* harmony export */   "watchMulticall": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Mx; },
/* harmony export */   "watchNetwork": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.QC; },
/* harmony export */   "watchPendingTransactions": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.us; },
/* harmony export */   "watchPublicClient": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.pC; },
/* harmony export */   "watchReadContract": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.jt; },
/* harmony export */   "watchReadContracts": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.fn; },
/* harmony export */   "watchWalletClient": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.Tb; },
/* harmony export */   "watchWebSocketPublicClient": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.fq; },
/* harmony export */   "writeContract": function() { return /* reexport safe */ _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__.n9; }
/* harmony export */ });
/* harmony import */ var _chunk_4E64EZ7V_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66403);
/* harmony import */ var _chunk_4E64EZ7V_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35194);
/* harmony import */ var _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63963);
/* harmony import */ var _chunk_TSH6VVF4_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57858);
/* harmony import */ var _chunk_BVC4KGLQ_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53324);
/* harmony import */ var _chunk_EQOEZP46_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74278);








/***/ }),

/***/ 35194:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ sepolia; }
/* harmony export */ });
/* harmony import */ var _utils_chain_defineChain_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86164);

const sepolia = /*#__PURE__*/ (0,_utils_chain_defineChain_js__WEBPACK_IMPORTED_MODULE_0__/* .defineChain */ .a)({
    id: 11155111,
    network: 'sepolia',
    name: 'Sepolia',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'SEP', decimals: 18 },
    rpcUrls: {
        alchemy: {
            http: ['https://eth-sepolia.g.alchemy.com/v2'],
            webSocket: ['wss://eth-sepolia.g.alchemy.com/v2'],
        },
        infura: {
            http: ['https://sepolia.infura.io/v3'],
            webSocket: ['wss://sepolia.infura.io/ws/v3'],
        },
        default: {
            http: ['https://rpc.sepolia.org'],
        },
        public: {
            http: ['https://rpc.sepolia.org'],
        },
    },
    blockExplorers: {
        etherscan: {
            name: 'Etherscan',
            url: 'https://sepolia.etherscan.io',
        },
        default: {
            name: 'Etherscan',
            url: 'https://sepolia.etherscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 751532,
        },
        ensRegistry: { address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e' },
        ensUniversalResolver: {
            address: '0x21B000Fd62a880b2125A61e36a284BB757b76025',
            blockCreated: 3914906,
        },
    },
    testnet: true,
});
//# sourceMappingURL=sepolia.js.map

/***/ }),

/***/ 84192:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bd": function() { return /* binding */ weiUnits; },
/* harmony export */   "Zn": function() { return /* binding */ gweiUnits; },
/* harmony export */   "ez": function() { return /* binding */ etherUnits; }
/* harmony export */ });
const etherUnits = {
    gwei: 9,
    wei: 18,
};
const gweiUnits = {
    ether: -9,
    wei: 9,
};
const weiUnits = {
    ether: -18,
    gwei: -9,
};
//# sourceMappingURL=unit.js.map

/***/ }),

/***/ 39625:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ formatEther; }
/* harmony export */ });
/* harmony import */ var _constants_unit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84192);
/* harmony import */ var _formatUnits_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15229);


/**
 * Converts numerical wei to a string representation of ether.
 *
 * - Docs: https://viem.sh/docs/utilities/formatEther.html
 *
 * @example
 * import { formatEther } from 'viem'
 *
 * formatEther(1000000000000000000n)
 * // '1'
 */
function formatEther(wei, unit = 'wei') {
    return (0,_formatUnits_js__WEBPACK_IMPORTED_MODULE_0__/* .formatUnits */ .b)(wei, _constants_unit_js__WEBPACK_IMPORTED_MODULE_1__/* .etherUnits */ .ez[unit]);
}
//# sourceMappingURL=formatEther.js.map

/***/ }),

/***/ 15229:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ formatUnits; }
/* harmony export */ });
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits.html
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */
function formatUnits(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith('-');
    if (negative)
        display = display.slice(1);
    display = display.padStart(decimals, '0');
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals),
    ];
    fraction = fraction.replace(/(0+)$/, '');
    return `${negative ? '-' : ''}${integer || '0'}${fraction ? `.${fraction}` : ''}`;
}
//# sourceMappingURL=formatUnits.js.map

/***/ }),

/***/ 21803:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ parseUnits; }
/* harmony export */ });
/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits.html
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */
function parseUnits(value, decimals) {
    let [integer, fraction = '0'] = value.split('.');
    const negative = integer.startsWith('-');
    if (negative)
        integer = integer.slice(1);
    // trim leading zeros.
    fraction = fraction.replace(/(0+)$/, '');
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1)
            integer = `${BigInt(integer) + 1n}`;
        fraction = '';
    }
    else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals),
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9)
            fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, '0');
        else
            fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    }
    else {
        fraction = fraction.padEnd(decimals, '0');
    }
    return BigInt(`${negative ? '-' : ''}${integer}${fraction}`);
}
//# sourceMappingURL=parseUnits.js.map

/***/ })

}]);